"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractTokenData = void 0;
/**
 * Вытащит `value` токенов, заменив ими токены в объекте.
 */
var extractTokenData = function (theme) {
    return Object.entries(theme).reduce(function (acc, _a) {
        var key = _a[0], token = _a[1];
        acc[key] = token.value;
        return acc;
    }, {});
};
exports.extractTokenData = extractTokenData;
//# sourceMappingURL=extractTokenData.js.map